import React from 'react';
import PropTypes from 'prop-types';
import {
  Segment,
  Header,
  Grid,
  Button,
} from 'semantic-ui-react';

const StepSegment = ({
  children,
  doneButton,
  hideBackButton,
  hideNextButton,
  onBackClick,
  onNextClick,
  title,
  visible,
}) => {
  return visible && (
    <Segment.Group raised style={ { marginTop: 30 } }>
      <Segment padded="very">
        <Header size="large">{ title }</Header>
      </Segment>

      <Segment padded="very">
        { children }

        <Grid style={ { marginTop: 30 } }>
          <Grid.Column width={ 8 }>
            { !hideBackButton && <Button onClick={ onBackClick }>Back</Button> }
          </Grid.Column>

          <Grid.Column textAlign="right" width={ 8 }>
            { !hideNextButton && <Button onClick={ onNextClick } primary>Next Step</Button> }

            { doneButton }
          </Grid.Column>
        </Grid>
      </Segment>
    </Segment.Group>
  );
};

StepSegment.defaultProps = {
  doneButton: null,
  hideBackButton: false,
  hideNextButton: false,
  visible: false,
};

StepSegment.propTypes = {
  children: PropTypes.node.isRequired,
  doneButton: PropTypes.node,
  hideBackButton: PropTypes.bool,
  hideNextButton: PropTypes.bool,
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool,

  // functions
  onBackClick: PropTypes.func,
  onNextClick: PropTypes.func,
};

export default StepSegment;



// WEBPACK FOOTER //
// ./src/components/Setup/components/StepSegment.js